<div
	class="jepto-page-editor-manage-pages"
	[class.jepto-page-editor-manage-pages--open]="open()"
	role="complementary"
	aria-modal="false"
	aria-labelledby="edit-pages-title"
>
	<aside class="jepto-page-editor-manage-pages__panel">
		<header class="jepto-page-editor-manage-pages__header">
			<button
				type="button"
				class="jepto-page-editor-manage-pages__close"
				aria-label="Close"
				(click)="onCancel()"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="18"
					height="18"
					viewBox="0 0 24 24"
					fill="none"
					aria-hidden="true"
				>
					<path
						d="M6 6l12 12M18 6L6 18"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
					/>
				</svg>
			</button>
			<h2
				id="edit-pages-title"
				class="jepto-page-editor-manage-pages__title"
			>
				Edit Pages
			</h2>
		</header>

		<div class="jepto-page-editor-manage-pages__toggle-row">
			<span class="jepto-page-editor-manage-pages__toggle-label">
				Show Tabs on Preview
			</span>
			<jepto-slide-toggle
				[checked]="workingTabsEnabled()"
				(change)="onTabsEnabledChange($event.checked)"
				ariaLabel="Show tabs on preview"
				testId="edit-pages-tabs-preview-toggle"
			></jepto-slide-toggle>
		</div>

		<div class="jepto-page-editor-manage-pages__list-wrap">
			<div
				class="jepto-page-editor-manage-pages__list"
				cdkDropList
				[cdkDropListData]="workingPages()"
				(cdkDropListDropped)="onDrop($event)"
			>
				@for (
					page of workingPages();
					track trackByPageId($index, page);
					let i = $index
				) {
					<div class="jepto-page-editor-manage-pages__row" cdkDrag>
						<div
							class="jepto-page-editor-manage-pages__drag"
							cdkDragHandle
							aria-label="Drag to reorder"
						>
							<mat-icon class="material-symbols-outlined"
								>drag_indicator</mat-icon
							>
						</div>
						<div class="jepto-page-editor-manage-pages__input-wrap">
							<jepto-ui-input
								[ngModel]="page.label"
								(ngModelChange)="setPageLabel(i, $event)"
								label="Page Name"
								[suffixIcon]="
									page.hidden ? 'visibility_off' : ''
								"
								(iconClick)="onPageInputIconClick(i, $event)"
								appearance="outline"
								[testId]="'edit-pages-input-' + i"
							/>
						</div>
						<div class="jepto-page-editor-manage-pages__menu-wrap">
							<button
								type="button"
								class="jepto-page-editor-manage-pages__menu-btn"
								(click)="toggleRowMenu(i, $event)"
								[attr.aria-expanded]="openRowMenuIndex() === i"
								aria-haspopup="menu"
								aria-label="More options"
							>
								<mat-icon class="material-symbols-outlined"
									>more_vert</mat-icon
								>
							</button>
							@if (openRowMenuIndex() === i) {
								<div
									class="jepto-page-editor-manage-pages__row-menu"
									role="menu"
									[attr.aria-label]="'Page options'"
								>
									<button
										type="button"
										class="jepto-page-editor-manage-pages__row-menu-item"
										role="menuitem"
										(click)="onRowMenuHideClick(i)"
									>
										{{ page.hidden ? 'Show' : 'Hide' }}
									</button>
									<button
										type="button"
										class="jepto-page-editor-manage-pages__row-menu-item jepto-page-editor-manage-pages__row-menu-item--danger"
										role="menuitem"
										[disabled]="workingPages().length <= 1"
										[attr.aria-disabled]="
											workingPages().length <= 1
										"
										[title]="
											workingPages().length <= 1
												? 'At least one page is required'
												: null
										"
										(click)="onRowMenuDeleteClick(i)"
									>
										Delete
									</button>
								</div>
							}
						</div>
					</div>
				}
				<button
					type="button"
					class="jepto-page-editor-manage-pages__add-page"
					(click)="onAddPage()"
				>
					<mat-icon class="material-symbols-outlined">add</mat-icon>
					<span>Add Page</span>
				</button>
			</div>
		</div>
	</aside>
</div>
